const defaultEnvironment = require("./environment.default");

const ciEnvironment = {
  ...defaultEnvironment,
  development: true,
  serverUrl: 'https://prod-admin.mexexchange.com/ecn-admin',
  serverPort: 443,
};
ciEnvironment.mexExchange.api.baseUrl = 'https://prod-admin.mexexchange.com/ecn-admin';
ciEnvironment.mexExchange.websockets.url = 'https://prod-admin.mexexchange.com/ecn-admin/ws';

export const environment = ciEnvironment;
